// extracted by mini-css-extract-plugin
module.exports = {"lenscap":"lenscap_lenscap__3vslc","lenscap__text":"lenscap_lenscap__text__3-GCN","button--hidden":"lenscap_button--hidden__2RDhY"};